// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__7Gbh+","success":"Chip_success__MEHyI","danger":"Chip_danger__cDefD","warning":"Chip_warning__8bJC9","neutral":"Chip_neutral__Irg5L"};